<div class="contract-list-page">
  <i class="reload" id="reload" (click)="getContractByIdLoad()">
    <img
      src="assets/icons/refresh-page-option.svg"
      [attr.alt]="'alt.refresh' | translate"
    />
  </i>
  <div class="contract-list-header">
    <div class="title">
      <h2>{{ 'Request for collection and processing of personal data' | translate }}</h2>
      <p
        class="body3 color-medium-gray">{{ 'Before you create a contract, you need to send a request to the participants of this contract to authorize the processing of personal data' | translate }}</p>
    </div>
    <app-request-filter
      [states]="requestTypesArray"
      [activeState]="requestType"
      [contractsAreLoading]="loadingRequests"
      (stateChange)="onStateChange($event)"
    >
    </app-request-filter>
  </div>
  <div class="w-100">
      <div class="redesign-list-group" *ngIf="requests && requests.length > 0">
        <app-preview-request
          *ngFor="let request of requests; let i = index"
          [ngClass]="'list-border w-100'"
          [id]="request.requestId"
          [title]="request.title[translateService.currentLang]"
          [state]="request.status"
          [isInitiator]="request.isInitiator"
          [createdDate]="request.updatedAt"
          [companyName]="request.companyName"
          [commentary]="request.commentary"
          [showAgreementLink]="true"
          [loadingAgreementLink]="loadingDownload[request.requestId]"
          [actionBtns]="getActionBtns(request)"
          [participants]="getParticipantsText(request)"
          (reject)="onReject($event)"
          (confirm)="onConfirm($event)"
          (download)="onDownload(request)"
          (getRequests)="getRequests(true, true)"
          (loadingTrue)="loadingTrue()"
          (loadingFalse)="loadingFalse()"
        ></app-preview-request>
      </div>

      <!-- Pagination -->
      <div class="pagination-container" *ngIf="requests && requests.length > 0 && totalPages > 1">
        <div class="pagination-wrapper">
          <button
            class="pagination-btn pagination-btn-nav-left"
            [disabled]="currentPage <= 1 || loadingRequests"
            (click)="previousPage()">
            <img
              src="assets/icons/icon-arrow-left.svg"
              [attr.alt]="'alt.paginationPrevious' | translate"
            >
          </button>

          <div class="pagination-numbers">
            <button
              *ngFor="let page of visiblePages"
              class="pagination-btn pagination-btn-number"
              [class.active]="page === currentPage"
              [disabled]="loadingRequests"
              (click)="page === -1 ? null : goToPage(page)">
              <span *ngIf="page === -1">...</span>
              <span *ngIf="page !== -1">{{ page }}</span>
            </button>
          </div>

          <button
            class="pagination-btn pagination-btn-nav"
            [disabled]="currentPage >= totalPages || loadingRequests"
            (click)="nextPage()">
            <img
              src="assets/icons/icon-arrow-right.svg"
              [attr.alt]="'alt.paginationNext' | translate"
            >
          </button>
        </div>
      </div>

      <div *ngIf="!requests || requests.length === 0 && !loadingRequests" class="empty-contract-list">
        <p class="body1 color-regular-gray">{{'Here you will find a list of requests' | translate}}</p>
      </div>
  </div>
</div>
